import { inject, Injectable } from '@angular/core';
import { Router } from '@angular/router';

import { ROUTES } from '@shared/constants/routes/routes.constants';
import { UserInfo } from '@shared/interfaces/user/user-info.interface';
import { UserService } from '@shared/service/user/user.service';
import { catchError, map, Observable, of } from 'rxjs';

@Injectable()
export class AdminGuard {
  private readonly router = inject(Router);
  private readonly userService = inject(UserService);

  canActivate(): Observable<boolean> {
    return this.userService.getUserInfo().pipe(
      map((user: UserInfo) => {
        if (user?.admin) {
          return true;
        }
        this.router.navigateByUrl('/' + ROUTES.FORBIDDEN);
        return false;
      }),
      catchError(() => {
        this.router.navigateByUrl('/' + ROUTES.HOME);
        return of(false);
      })
    );
  }
}
